module.exports = __webpack_public_path__ + "img/claudia-van-zyl.5f35f446.png";